      <!-- Icône cookie -->
      <!-- <div class="cookie-icon">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="#FFA409"/>
          <circle cx="8" cy="10" r="1" fill="#000000"/>
          <circle cx="16" cy="9" r="1" fill="#000000"/>
          <circle cx="10" cy="14" r="1" fill="#000000"/>
          <circle cx="15" cy="15" r="1" fill="#000000"/>
          <circle cx="12" cy="8" r="1" fill="#000000"/>
        </svg>
        <h3 class="cookie-title">{{ $t('footer.cookie_title') }} <span class="highlight">cookies</span></h3>
      </div> -->
<template>
  <div v-if="showCookiePopup" class="cookie-popup-overlay">
    <div class="cookie-popup" v-responsive.lg.xl>
      <!-- Contenu -->
      <div class="cookie-content">
        <!-- <h3 class="cookie-title">We use <span class="highlight">cookies</span></h3> -->
        <p class="cookie-text">
          {{ $t('footer.cookie_content[0]') }} <br> {{ $t('footer.cookie_content[1]') }} <a href="javascript:void(0)" @click="toPolicy">{{ $t('footer.cookie_content[2]') }}</a>

        </p>
      </div>
      
      <!-- Boutons -->
      <div class="cookie-actions">
        <button class="btn-later" @click="handleLater">{{ $t('footer.cookie_button[0]') }}</button>
        <button class="btn-accept" @click="handleAccept">{{ $t('footer.cookie_button[1]') }}</button>
      </div>
    </div>
<div class="cookie-popup" v-responsive.sm.xs>
      <!-- Contenu -->
      <div class="cookie-content">
        <!-- <h3 class="cookie-title">We use <span class="highlight">cookies</span></h3> -->
        <p class="cookie-text">
          {{ $t('footer.cookie_content[0]') }} <br> {{ $t('footer.cookie_content[1]') }} <a href="javascript:void(0)" @click="toPolicy">{{ $t('footer.cookie_content[2]') }}</a>

        </p>
      </div>
      
      <!-- Boutons -->
      <div class="cookie-actions">
        <button class="btn-later" @click="handleLater">{{ $t('footer.cookie_button[0]') }}</button>
        <button class="btn-accept" @click="handleAccept">{{ $t('footer.cookie_button[1]') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookiePopup',
  data() {
    return {
      showCookiePopup: true
    }
  },
  methods: {
    toPolicy(){
        this.$router.push('/info/legale')
    },
    handleAccept() {
      // Sauvegarder le consentement
      localStorage.setItem('cookieConsent', 'accepted')
      this.showCookiePopup = false
      this.$emit('accepted')
    },
    handleLater() {
      // Sauvegarder que l'utilisateur a choisi "plus tard" avec un timestamp
      const laterTimestamp = Date.now()
      localStorage.setItem('cookieConsent', 'later')
      localStorage.setItem('cookieLaterTimestamp', laterTimestamp.toString())
      
      // Fermer temporairement
      this.showCookiePopup = false
      this.$emit('later')
      
      // Réafficher après 24h
      setTimeout(() => {
        const consent = localStorage.getItem('cookieConsent')
        if (consent !== 'accepted') {
          localStorage.removeItem('cookieConsent')
          localStorage.removeItem('cookieLaterTimestamp')
          this.showCookiePopup = true
        }
      }, 24 * 60 * 60 * 1000)
    }
  },
  mounted() {
    // Vérifier si l'utilisateur a déjà accepté
    const consent = localStorage.getItem('cookieConsent')
    const laterTimestamp = localStorage.getItem('cookieLaterTimestamp')
    
    if (consent === 'accepted') {
      this.showCookiePopup = false
    } else if (consent === 'later' && laterTimestamp) {
      // Vérifier si les 24h sont écoulées
      const now = Date.now()
      const laterTime = parseInt(laterTimestamp)
      const twentyFourHours = 24 * 60 * 60 * 1000
      
      if (now - laterTime < twentyFourHours) {
        // Moins de 24h, ne pas afficher le popup
        this.showCookiePopup = false
      } else {
        // Plus de 24h, nettoyer le localStorage et afficher le popup
        localStorage.removeItem('cookieConsent')
        localStorage.removeItem('cookieLaterTimestamp')
        this.showCookiePopup = true
      }
    }
  }
}
</script>

<style scoped>
.cookie-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent; /* Suppression de l'overlay sombre */
  display: flex;
  justify-content: flex-start; /* Alignement à gauche */
  align-items: flex-end; /* Alignement en bas */
  z-index: 9999;
  pointer-events: none; /* Permet de cliquer à travers l'overlay */
}

.cookie-popup {
  background: linear-gradient(135deg, #fff 0%, #fff 100%);
  border-radius: 20px;
  padding: 30px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  position: relative;
  animation: slideInFromLeft 0.3s ease-out;
  margin: 20px; /* Marge depuis les bords */
  pointer-events: auto; /* Réactive les clics sur le popup */
}

@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.cookie-icon {
  /* margin-bottom: 20px; */
  display: flex;
  justify-content: center;
}

.cookie-content {
  margin-bottom: 10px;
}
.cookie-content a {
    text-decoration: none;
    font-weight: 700;
    color: #ffa409;
}

.cookie-title {
  color: black;
  font-size: 20px;
  font-weight: 400;
  margin: 10px 0 0 10px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.highlight {
  color: #ffa409;
  font-weight: 600;
}

.cookie-text {
  color: #000;
  font-size: 15px;
  margin: 0;
  line-height: 1.5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.cookie-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.btn-later {
  background: #efeeee;
  border: none;
  color: #8a8a8a;
  font-size: 16px;
  padding: 12px 24px;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.btn-later:hover {
    background: #efeeee;

   border-radius: 25px;
  color: #cccccc;
  /* background: rgba(255, 255, 255, 0.1); */
}

.btn-accept {
  background: #ffa400;
  border: none;
  color: black;
  font-size: 16px;
  font-weight: 500;
  padding: 12px 30px;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.btn-accept:hover {
  background: #ffa409;
  transform: translateY(-2px);
  border-radius: 25px;
  box-shadow: 0 5px 15px rgba(242, 180, 9, 0.3);
}

/* Version mobile */
@media (max-width: 480px) {
  .cookie-popup {
    /* margin: 10px; Marge réduite sur mobile */
    padding: 25px;
    max-width: calc(100% - 20px); /* S'assure que le popup ne dépasse pas */
  }
  
  .cookie-title {
    font-size: 15px;
  }
  
  .cookie-text {
    font-size: 14px;
  }
  
  .cookie-actions {
    flex-direction: column;
    gap: 10px;
  }
  
  .btn-later,
  .btn-accept {
    width: 100%;
    padding: 15px;
  }
}
</style>